import { render, staticRenderFns } from "./QuestionConfigMediaUpload.vue?vue&type=template&id=1a513003&scoped=true"
import script from "./QuestionConfigMediaUpload.vue?vue&type=script&lang=js"
export * from "./QuestionConfigMediaUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a513003",
  null
  
)

export default component.exports